<template>
	<aside class="filter product-filter" id="filter" :class="showfilters ? 'open' : null">
		<div class="filter-header">
			<h2>Filter</h2>
			<a href="javascript:void(0)" class="js-filter-clear filter-clear hide-mobile" v-on:click="clearFilters()">clear all filters</a>
			<i class="icon icon-close filter-close hide-desktop" v-on:click="updateShowFilters"></i>
		</div>
		<div class="filters" id="filters">

			<div class="filter-section categories">

				<h3>Category</h3>
				<ul class="category-list">

					<li class="category" v-for="category in categoryfilters">

						<div class="category-header"
							 :class="category.isOpen ? 'open' : null"
							 v-on:click="toggleChildrenMenu(category)"
							 v-on:keyup.enter="toggleChildrenMenu(category)"
							 tabindex="0">
							<span v-if="category.hasActiveFilters" class="active-indicator"></span>
							{{category.CategoryName}}
						</div>

						<div class="child-categories" :class="category.isOpen ? 'open' : null">
							<div class="child-menu-top">
								<div class="child-categories-header" v-on:click="toggleChildrenMenu(category)">
									<span class="icon icon-angle-left hide-desktop"></span>
									{{category.CategoryName}}
								</div>

								<div class="form-group form checkbox-input select-all">
									<input id="child-select-all" :checked="category.isSelectAll" type="checkbox" v-on:change="selectUnselectChildren(category)"></input>
									<label for="child-select-all">Select All</label>
								</div>
							</div>

							<ul class="filters-categories child-categories-list checkbox-grid three-column" :class="category.isOpen ? 'open' : null">
								<li class="category" v-for="child in category.ChildCategories">
									<div class="form-group form checkbox-input">
										<input :id="'filter-' + child.CategoryStr" type="checkbox" v-model="filters.categories" :value="child.CategoryStr" v-on:change="updateFilterList(category, child)"></input>
										<label :for="'filter-' + child.CategoryStr">{{child.CategoryName}}</label>
									</div>
								</li>
							</ul>

							<div class="filter-apply hide-mobile">
								<button class="btn" v-on:click="applyFilters()">Apply Filters</button>
							</div>
						</div>

					</li>

				</ul>
			</div>
			<a href="javascript:void(0)" class="js-filter-clear filter-clear hide-desktop" v-on:click="clearFilters()">clear all filters</a>
			<div class="filter-section supplier-types">

				<h3>Supplier Type</h3>
				<ul class="filters-categories input-group">

					<li class="category">
						<div class="form-group form checkbox-input">
							<input id="filter-my-supplier" type="checkbox" :checked="filters.isMySupplier" value="filters.isMySupplier" v-on:change="filters.isMySupplier = !filters.isMySupplier"></input>
							<label for="filter-my-supplier">MySupplier</label>
						</div>
					</li>
					<li class="category">
						<div class="form-group form checkbox-input">
							<input id="filter-cap" type="checkbox" :checked="filters.isCAP" value="filters.isCAP" v-on:change="filters.isCAP = !filters.isCAP"></input>
							<label for="filter-cap">CAP</label>
						</div>
					</li>
					<li class="category">
						<div class="form-group form checkbox-input">
							<input id="filter-cap" type="checkbox" :checked="filters.isCOOP" v-on:change="filters.isCOOP = !filters.isCOOP"></input>
							<label for="filter-cap">Co-op</label>
						</div>
					</li>
					<li class="category">
						<div class="form-group form checkbox-input">
							<input id="filter-cap" type="checkbox" :checked="filters.isNAPRating" v-on:change="filters.isNAPRating = !filters.isNAPRating"></input>
							<label for="filter-cap">NAP Star Rating</label>
						</div>
					</li>
					<li class="category">
						<div class="form-group form checkbox-input">
							<input id="filter-cap" type="checkbox" :checked="filters.isB2B" v-on:change="filters.isB2B= !filters.isB2B"></input>
							<label for="filter-cap">B2B</label>
						</div>
					</li>

				</ul>
			</div>
		</div>
		<div class="filter-actions" :class="filterActionsStuck ? 'static' : ''">
			<button class="btn" v-on:click="applyFilters()">Apply Filters</button>
			<a href="javascript:void(0)" class="js-filter-clear hide-mobile" v-on:click="clearFilters()">Clear Filters</a>
		</div>
	</aside>

</template>


<script>
	import Analytics from 'lib/analytics';

	export default {
		data: function () {
			return {
				filterActionsStuck: false,
				styleObject: {},
				categoryfilters: [],
				activeCategories: [],
				suppliertypes: [],
				// Categories already sent to GTM; applying only reports the difference
				trackedCategories: [],
				//includeMemberServices: false,
                filters: {
                    isMySupplier: false,
                    isCAP: false,
                    isCOOP: false,
					isNAPRating: false,
					isB2B: false,
					categories: []
				},
			}
		},
		props: {
			showfilters: {
				type: Boolean,
				default: () => false
			},

		},
		watch: {
			showfilters: function (newVal) {
				this.showfilters = newVal;

				let body = document.getElementsByTagName("BODY")[0];

				if (newVal === true) {
					body.classList.add('collapse-shown');
					body.classList.remove('collapse-hide');

					setTimeout(() => {
						$('#filters .js-filter-clear').focus();
					}, 1000);
				}
				else {
					body.classList.add('collapse-hide');
					body.classList.remove('collapse-shown');
				}
			}

		},

		mounted() {
			this.suppliertypes = window.suppliertypes;
            this.categoryfilters = window.categoryfilters;

			for (let category of this.categoryfilters) {
				this.$set(category, 'isOpen', false);
				this.$set(category, 'hasActiveFilters', false);
				this.$set(category, 'isSelectAll', false)

				for (let child of category.ChildCategories) {
					this.$set(child, 'isChecked', false);
				}
			}

            // Get selected categories from session storage
            const filterData = JSON.parse(sessionStorage.getItem('productsFilters'));

            if (filterData) {
                // Set the filters and apply those changes
                this.filters = filterData;

                // Seed the tracked list so restored filters aren't reported again
                this.trackedCategories = (this.filters.categories || []).slice();

                this.applyFilters();

                // While filters are being applied, fix the view to show which categories have selected children
                for (const category of this.filters.categories) {
                    const categoryID = category.substring(0, category.indexOf('-'));

                    for (const filter of this.categoryfilters) {
                        if (filter.CategoryStr == categoryID) {
                            this.$set(filter, 'hasActiveFilters', true);

                            break;
                        }
                    }
                }
            }

			document.getElementById("filter")
				.addEventListener("click", function (e) {
					e.stopPropagation();
				}
				);
			let _this = this;
			document.body.addEventListener("click",
				function (e) {
					for (let category of categoryfilters) {
						_this.$set(category, 'isOpen', false);
						document.getElementById('item-list').classList.remove('menu-open');
					}
				}
			);

			$(window).on('scroll', e => { this.stickFilterActions() });
		},
		methods: {
			applyFilters() {

				this.trackAppliedCategories();

				// convert for api call
				let formatFilters = Object.assign({}, this.filters);

				// set bools
				//formatFilters.isMySupplier = this.isMySupplier;
				//formatFilters.isCAP = this.isCAP;
				//formatFilters.isCOOP = this.isCOOP;
				//formatFilters.isNAPRating = this.isNAPRating;
				//formatFilters.includeMemberServices = this.includeMemberServices;

				// encode strings
				formatFilters.categories = formatFilters.categories;

				// loop through all categories and close child menus
				this.categoryfilters.forEach(function (cat) {
					cat.isOpen = false;
				});

                $('#filters').css('overflow-y', 'scroll');

                this.$emit('setproductfilter', formatFilters);
                this.updateShowFilters();

				//get rid of list overlay
				document.getElementById('item-list').classList.remove('menu-open');
			},
			clearFilters() {
				this.filters.supplierTypes = [];
				this.filters.categories = [];
                this.filters.isCAP = false;
                this.filters.isCOOP = false;
                this.filters.isMySupplier = false;
				this.filters.isNAPRating = false;
				this.filters.isB2B = false;

				let category = this.categoryfilters;

				for (var i = 0; i < category.length; i++) {

					category[i].isOpen = false;
					category[i].hasActiveFilters = false;
					category[i].isSelectAll = false;

					for (var c = 0; c < category[i].ChildCategories.length; c++) {
						category[i].ChildCategories[c].isChecked = false;
					}
				}

				$('#filters').css('overflow-y', 'scroll');

				// Reset tracking so re-picking a category counts as a fresh search
				this.trackedCategories = [];

				this.$emit('clearfilters');
				this.applyFilters();
			},
			selectUnselectChildren(cat) {

				//Loop through all current filters add/remove from array as needed
				for (let child of cat.ChildCategories) {

					let index = this.filters.categories.indexOf(child.CategoryStr);

					if (cat.isSelectAll) {
						this.filters.categories.splice(index, 1);
						//this.filters.categories = [];
						cat.hasActiveFilters = false;
						child.isChecked = false;

					}
					else {
						if (index === -1) {
							this.filters.categories.push(child.CategoryStr);
							cat.hasActiveFilters = true;
							child.isChecked = true;
						}
					}
				}

				cat.isSelectAll = !cat.isSelectAll;
			},
			stickFilterActions() {
				let $stickyElem = $('.filter-actions');
				let $filters = $('#filters');
				let filterOffset = Math.round($filters.offset().top);
				let filterHeight = $filters.outerHeight();
				let stickyHeight = $stickyElem.outerHeight();
				let viewHeight = $(window).height();
				let totalHeight = filterHeight + (stickyHeight * 2);

				$('.filter + .content-wrapper-main').css('minHeight', totalHeight);

				let offset = filterOffset + filterHeight + stickyHeight - $(window).scrollTop();

				if ((offset <= viewHeight) && !this.filterActionsStuck) {
					this.filterActionsStuck = true;
				}
				if ((offset > viewHeight) && this.filterActionsStuck) {
					this.filterActionsStuck = false;
				}
			},
			// One event per category, since GA4 can't report on an array parameter.
			// Reads filters.categories because child.isChecked isn't restored on mount.
			trackAppliedCategories() {
				let applied = this.filters.categories || [];
				let newlyApplied = applied.filter(str => this.trackedCategories.indexOf(str) === -1);

				this.trackedCategories = applied.slice();

				if (!newlyApplied.length) {
					return;
				}

				for (let category of this.categoryfilters) {
					for (let child of category.ChildCategories) {

						if (newlyApplied.indexOf(child.CategoryStr) === -1) {
							continue;
						}

						Analytics.push('product_filter_select', {
							filter_group: category.CategoryName,
							filter_category: child.CategoryName,
							filter_category_id: child.CategoryStr
						});
					}
				}
			},
			toggleChildrenMenu(cat) {
				let list = document.getElementById('item-list');

				if (cat.isOpen) {
					cat.isOpen = false;
					list.classList.remove('menu-open');

					setTimeout(() => {
						$('#filters').css('overflow-y', 'scroll');
						$('#filters .js-filter-clear').focus();
					}, 500);
				}
				else {
					for (let item of this.categoryfilters) {
						item.isOpen = false;
					}

					cat.isOpen = true;

					list.classList.add('menu-open');
					$('#filters').css('overflow-y', 'hidden');
				}
			},
			updateShowFilters() {
				this.$emit('updateshowfilters', false);
			},
			updateFilterList(cat, child) {

				let index = this.filters.categories.indexOf(child.CategoryStr);

				// If the child category isn't checked go ahead an put it in the array and set the parent to active
				if (!child.isChecked) {
					cat.hasActiveFilters = true;
					child.isChecked = true;
				}
				else {
			
					child.isChecked = false;
					cat.isSelectAll = false;

					// Temp bool for tracking whether siblings are checked
					let checkedFound = false;

					// Loop through sibling child categories and set Temp bool to true if any are found checked then bail
					for (var i = 0; i < cat.ChildCategories.length; i++) {

						if (cat.ChildCategories[i].isChecked) {
							checkedFound = true;
							break;
						}
					}

					// Since for is a blocking loop this won't run until after the loop has completed
					// If no checked siblings are found then set parent to inactive
					if (!checkedFound) {
						cat.hasActiveFilters = false;
					}
				}
			}
		}
	}
</script>